import { useContext, useState } from "react";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/Accounts/NewServerConnection.css";
import { AccountContext } from "./AccountProvider";
import { thingsBoardMicroserviceUrl } from "../../../../microservices/thingsboard_microservice";
import { AppContext } from "../../../AppProvider";
const NewServerConnection = () =>{
    const {user,logout} = useContext(AppContext);
    const {showNewServerConnectionWindow,setShowNewServerConnectionWindow} = useContext(AccountContext);
    const [connectionName,setConnectionName] = useState('');
    const [serverUrl,setServerUrl] = useState('');
    const [serverUsername,setServerUsername] = useState('');
    const [serverPassword,setServerPassword] = useState('');
    const [defaultConnection,setDefaultConnection] = useState(false);
    const [tenantAdministratorProfileCreateStatus,setTenantAdministratorProfileCreateStatus] = useState('');
    const entryInvalidTitle = () =>{
        if(connectionName.length <= 0) return "Connection name cannot be empty";
        else if(serverUrl.length <= 0) return "Server url cannot be empty";
        else if(serverUsername.length <= 0) return "Server username cannot be empty";
        else if(serverPassword.length <= 0) return "Server password cannot be empty";
        else if(serverPassword.length <= 0) return "Server password cannot be empty";
        else return "";
    };
    const createTenantAdminProfile = async() =>{
        try{
            setTenantAdministratorProfileCreateStatus('creating');
            const payload = {
                profileName:connectionName,
                serverUrl:serverUrl,
                serverUsername:serverUsername,
                serverPassword:serverPassword,
                defaultProfile:defaultConnection
            }
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles`;
            const response = await fetch(url,{
                method:'POST',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user?.access_token}`
                },
                body:JSON.stringify(payload)
            });
            if(response.ok){
                setTenantAdministratorProfileCreateStatus('created');
            }
            else if(response.status === 401) logout();
            else throw new Error(`status code: ${response.status}`)
        }
        catch(error){
            console.error('An error occurred when creating a tenant administrator profile',error);
        }
    };
    const clearEntries = () =>{
        setConnectionName('');
        setServerUrl('');
        setServerUsername('');
        setServerPassword('');
        setDefaultConnection(false);
    };
    const disposeWindow = () =>{
        clearEntries();
        setTenantAdministratorProfileCreateStatus('');
        setShowNewServerConnectionWindow(false);
    };
    if(!showNewServerConnectionWindow) return null;
    return(
        <div className="tenant-administrator-account-new-server-connection-parent-container">
            {tenantAdministratorProfileCreateStatus === ''?
            (<div className="tenant-administrator-account-new-server-connection-container">
                <div className="tenant-administrator-account-new-server-connection-header">
                    <div>
                        <h1>Add server connection</h1>
                    </div>
                    <div className="buttons-container">
                        <button className="help-button" title="Go to help page">?</button>
                        <button className="close-button" onClick={() => disposeWindow()}>&#10006;</button>
                    </div>
                </div>
                <div className="tenant-administrator-account-new-server-connection-body">
                    <div className="tenant-administrator-account-new-server-connection-entry-container">
                        <p>Connection name<span>*</span></p>
                        <input value={connectionName} onChange={(e) => setConnectionName(e.target.value)}/>
                    </div>
                    <div className="tenant-administrator-account-new-server-connection-entry-container">
                        <p>Server url<span>*</span></p>
                        <input value={serverUrl} onChange={(e) => setServerUrl(e.target.value)}/>
                    </div>
                    <div className="tenant-administrator-account-new-server-connection-entry-container">
                        <p>Username<span>*</span></p>
                        <input value={serverUsername} onChange={(e) => setServerUsername(e.target.value)}/>
                    </div>
                    <div className="tenant-administrator-account-new-server-connection-entry-container">
                        <p>Password<span>*</span></p>
                        <input value={serverPassword} onChange={(e) => setServerPassword(e.target.value)}/>
                    </div>
                    <div className="tenant-administrator-account-new-server-connection-default-selection-container" title="Make this connection the default connection">
                        <p>Default Connection</p>
                        <input
                            type="checkbox"
                            checked={defaultConnection}
                            onChange={(e) => setDefaultConnection(e.target.checked)}
                        />
                    </div>
                </div>
                <div className="tenant-administrator-account-new-server-connection-control-buttons-container">
                    <button className="cancel-button" onClick={() =>disposeWindow()}>Cancel</button>
                    <button className={`add-button ${entryInvalidTitle().length > 0? '':'active'}`}
                        title={entryInvalidTitle()}
                        onClick={async() =>{
                            if(entryInvalidTitle().length > 0) return;
                            await createTenantAdminProfile();
                        }}>Add</button>
                </div>
            </div>
            ):
            tenantAdministratorProfileCreateStatus === 'creating'?
            (
                <div className="tenant-administrator-account-creating-server-connection-container">
                    <div></div>
                    <p>Creating server connection, please wait...</p>
                </div>
            ):(
                <div className="tenant-administrator-account-created-server-connection-container">
                    <p><span>&#10003;</span>Server connection "{connectionName}" created successfully"</p>
                    <div className="control-buttons-container">
                        <button onClick={() => disposeWindow()}>Okay</button>
                    </div>
                </div>
            )}
        </div>
    );
};
export default NewServerConnection;